import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import Page from "../../components/Page";
import { ATTICUS_PAGE_PREFIX } from "../../constants";
import { useAuthContext } from "../../AuthContextWrapper";
import { getGreeting } from "../../utils/getGreeting";
import { EstateSummaryCard } from "./EstateSummaryCard";

export const Home = (): JSX.Element => {
  const { user, estates } = useAuthContext()
  return estates !== undefined ? (
    <Page title={`${ATTICUS_PAGE_PREFIX} - Home`}>
      <>
        <Typography
          variant="h2"
          sx={{
            mb: 4,
          }}
        >
          {getGreeting(user)}
        </Typography>
        <EstateSummaryCard />

        {/*<Typography variant="h4" sx={{ my: 2 }}>*/}
        {/*  Updates for you*/}
        {/*</Typography>*/}
        {/*<EngagementCard />*/}

        {/*<Typography variant="h4" sx={{ mt: 4, mb: 2 }}>*/}
        {/*  Upcoming deadlines*/}
        {/*</Typography>*/}
        {/*<ActionCard*/}
        {/*  icon={*/}
        {/*    <img*/}
        {/*      src={megaphoneImg}*/}
        {/*      title="Unlock your deadlines"*/}
        {/*      alt="Unlock your deadlines"*/}
        {/*    />*/}
        {/*  }*/}
        {/*  title="Unlock your deadlines"*/}
        {/*  buttonText="Complete my profile"*/}
        {/*  clickHandler={() => {*/}
        {/*    console.log("clicked Complete my profile");*/}
        {/*  }}*/}
        {/*/>*/}

        {/*<Typography variant="h4" sx={{ mt: 4, mb: 2 }}>*/}
        {/*  Your to-do list*/}
        {/*</Typography>*/}
        {/*<ActionCard*/}
        {/*  icon={*/}
        {/*    <img*/}
        {/*      src={clipboardImg}*/}
        {/*      title="Unlock the rest of your to-do list"*/}
        {/*      alt="Unlock the rest of your to-do list"*/}
        {/*    />*/}
        {/*  }*/}
        {/*  title="Unlock the rest of your to-do list"*/}
        {/*  buttonText="Complete my profile"*/}
        {/*  clickHandler={() => {*/}
        {/*    console.log("clicked Complete my profile");*/}
        {/*  }}*/}
        {/*/>*/}
        {/*<ActionCard*/}
        {/*  icon={*/}
        {/*    <img*/}
        {/*      src={formImg}*/}
        {/*      title="Check out your required probate forms"*/}
        {/*      alt="Check out your required probate forms"*/}
        {/*    />*/}
        {/*  }*/}
        {/*  title="Check out your required probate forms"*/}
        {/*  buttonText="View forms"*/}
        {/*  clickHandler={() => {*/}
        {/*    console.log("clicked View forms");*/}
        {/*  }}*/}
        {/*/>*/}

        {/*<Box sx={{ my: 2 }}>*/}
        {/*  <Link to={`${SCREEN_PATHS.flow}/${onBoardingFlow.flowPath}`}>*/}
        {/*    Return to On-boarding*/}
        {/*  </Link>*/}
        {/*  /!*<br />*!/*/}
        {/*  /!*<Link to={`${SCREEN_PATHS.flow}/${noticeToCreditorsFlow.flowPath}`}>*!/*/}
        {/*  /!*  Start Notice to creditors*!/*/}
        {/*  /!*</Link>*!/*/}
        {/*</Box>*/}
        <Box sx={{ my: 2 }}>
          <Typography variant="h5" gutterBottom>
            User logged in
          </Typography>
          <Typography>
            <strong>first name:</strong> {user?.first}
          </Typography>
          <Typography>
            <strong>last name:</strong> {user?.last}
          </Typography>
          <Typography>
            <strong>email:</strong> {user?.email}
          </Typography>
        </Box>
      </>
    </Page>
  ) : (
    <></>
  );
};
